import React, { useContext } from "react";
import { FooterContext } from "../../../../store/context/footer-context";
import { ANALYTICS_CATEGORY, AVAILABLE_LOGOS } from "../index.content";
import SVG_ALIBABA from "../../../../assets/images/vector/Layout/Footer/logo_alibaba.svg";
import TrackedLink from "../../../Analytics/TrackedLink";
import "./index.scss";

const Logos = () => {
  const { language } = useContext(FooterContext);
  const { logoPath, logoSrc } = AVAILABLE_LOGOS[language];

  return (
    <div className="GCL-F-L">
      <TrackedLink path={logoPath} category={ANALYTICS_CATEGORY} action="CTA">
        <img
          className="GCL-F-L__scout"
          src={logoSrc}
          alt="logo"
          loading="lazy"
        />
      </TrackedLink>
      <img
        className="GCL-F-L__alibaba"
        src={SVG_ALIBABA}
        alt="Alibaba"
        loading="lazy"
      />
    </div>
  );
};

export default Logos;
